export default {
  airtableApiKey: process.env.REACT_APP_AIRTABLE_API_KEY || "",
  airtableApiId: process.env.REACT_APP_AIRTABLE_API_ID || "",
  airtableReportUrl: process.env.REACT_APP_AIRTABLE_REPORT_URL || "",
  airtableFeedbackUrl: process.env.REACT_APP_AIRTABLE_FEEDBACK_URL || "",
  airtableSuggestionsUrl: process.env.REACT_APP_AIRTABLE_SUGGESTIONS_URL || "",
  airtableEmailUrl: process.env.REACT_APP_AIRTABLE_EMAIL_URL || "",
  googleAnalyticsKey: process.env.REACT_APP_GOOGLE_ANALYTICS_KEY || "",
  mailchimpUrl: process.env.REACT_APP_AIRTABLE_MAILCHIMP_URL || "",
  buyMeACoffeeDonateUrl: process.env.REACT_APP_DONATE_URL || "",
};



// WEBPACK FOOTER //
// ./src/config/index.js